import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * HVAC Icon Style 02 - Air (Material Symbol)
 * An air/wind style icon for HVAC
 * - isOn = true: 青色實心
 * - isOn = false: 灰色空心
 * 
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:air
 */
export const Style02_AirConditioning: React.FC<DeviceIconProps> = ({ 
  isOn = false, 
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = isOn ? 'text-cyan-500' : 'text-slate-400';

  return (
    <span 
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{ 
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' ${isOn ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      air
    </span>
  );
};

export default Style02_AirConditioning;
